import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {useTranslation} from "react-i18next";


const UserRoleAutocomplete = ({ setUserRole, ...props }) => {
    const {t} = useTranslation("inputs");

    const roleOptions = ["ADMIN", "WG_ADMIN", "WG_USER"]; // TODO: save the enum in a config file or fetch from the backend
    const roleLabels = roleOptions.reduce((acc, r ) => {
        acc[r] = t(`enums:role.${r}`);
        return acc;
    }, {})

    return <Autocomplete
        id="role-autocomplete"
        options={roleOptions}
        getOptionLabel={(role) => roleLabels[role]}
        filterOptions={(x) => x}
        onChange={(e, value) => setUserRole(value)}
        renderInput={(params) => (
            <MDInput {...params}
                     variant="standard"
                     label={t('userRoleAutocomplete.label')}
                     placeholder={t('userRoleAutocomplete.placeholder')}
            />
        )}
        {...props}
    />
}

export default UserRoleAutocomplete;